export const filterData = {
    licenseType: [
        {name: 'RM', slug: 'RM'},
        {name: 'RF', slug: 'RF'}
    ],

    orientation: [
        {name: 'Horizontal', slug: 'horizontal'},
        {name: 'Vertical', slug: 'vertical'},
    ],

    imageType: [
        {name: 'Photo', slug: 'photo'},
        {name: 'Vector', slug: 'vector'},
        {name: 'Illustration', slug: 'illustration'}
    ],

    noOfPeople: [
        {name: 'No People', slug: '0'},
        {name: 'One People', slug: '1'},
        {name: 'Two People', slug: '2'},
        {name: 'Three People', slug: '3'},
        {name: 'Four People', slug: '4'},
        {name: 'Five People', slug: '5'}
    ],

    gender: [
        {name: 'Male', slug: 'male'},
        {name: 'Female', slug: 'female'}
    ],

    age: [
        {name: 'Baby', slug: 'baby'},
        {name: 'Teenager', slug: 'teenager'},
        {name: 'Adult', slug: 'adult'},
        {name: 'Senior', slug: 'senior'}
    ],

    ethnicity: [
        {name: 'Indian', slug: 'indian'},
        {name: 'Other', slug: 'other'}
    ],

    creative_indian_collections: [{id: 23, name: 'Zero-03'}, {id: 207, name: ''}, {id: 205, name: ''}, {id: 21, name: ''}, {
        id: 197,
        name: 'Indiapix Premium'
    }, {id: 24, name: ''}, {id: 12, name: ''}, {id: 218, name: ''}, {id: 22, name: ''}, {id: 25, name: ''}, {id: 26, name: ''}, {
        id: 14,
        name: ''
    }, {id: 220, name: ''}, {id: 215, name: ''}],
    editorial_indian_collections: [13, 208, 216, 217, 220, 215],

    creative_international_collections: [213, 212, 41, 144, 182, 116, 72, 154, 161, 187, 130, 179, 210, 211, 160, 172, 93, 62, 88, 220, 215, 223, 224, 225],
    editorial_international_collections: [214, 132, 41, 144, 182, 116, 72, 154, 161, 187, 130, 179, 210, 211, 160, 172, 93, 62, 88, 220, 215, 224]

    // video_collections: [211]

};
